<template>
  <div>
    <div
      v-if="hasRole('ROLE_SALES_MANAGER') || hasRole('ROLE_BUSINESS_ADMIN')"
      class="level is-mobile"
    >
      <div class="level-left" />
      <div class="level-right">
        <div class="level-item">
          <b-field class="is-light">
            <b-select
              v-model="selected"
              placeholder="FILTER BY"
              size="is-small"
            >
              <option value="all">
                All
              </option>

              <hr class="dropdown-divider">

              <option value="self">
                Self
              </option>

              <hr class="dropdown-divider">

              <option
                v-for="(subordinate, subordinateIndex) in subordinatesList"
                :key="subordinateIndex"
                :value="subordinate.id"
              >
                {{ subordinate.fullname.trim() }}
              </option>
              <hr class="dropdown-divider">

              <option
                v-for="team in teams"
                :key="team.id"
                :value="`team${team.id}`"
              >
                {{ team.name }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>

    <div class="card is-rounded-card is-spaced-top">
      <header class="card-header">
        <p class="card-header-title">
          open opportunities by salesperson
        </p>
      </header>

      <div class="card-content">
        <highcharts
          v-if="hasData"
          :options="openOpportunitiesBySalespersonSeries"
        />

        <div
          v-else
          class="level is-mobile"
        >
          <div class="level-item has-text-centered">
            <div>
              <figure class="image">
                <img
                  src="@/assets/images/no-data.svg"
                  alt="No Data"
                >
              </figure>
              <b-button
                type="is-primary"
                size="is-small"
              >
                no data found
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Chart } from 'highcharts-vue';

export default {
  name: 'OpenOpportunitiesBySalesperson',

  components: {
    highcharts: Chart,
  },

  data: () => ({
    self: localStorage.getItem('user_id'),
    selected: '',
  }),

  computed: {
    ...mapGetters({
      openOpportunitiesBySalesperson: 'Graphs/getOpenOpportunitiesBySalesperson',
      subordinatesList: 'Users/getSubordinates',
      teams: 'Graphs/getTeams',
    }),

    hasData() {
      const data = { ...this.openOpportunitiesBySalesperson };

      return !!(Object.entries(data).length > 0 && Object.entries(data)[0][1]);
    },

    openOpportunitiesBySalespersonSeries() {
      const data = { ...this.openOpportunitiesBySalesperson };

      const categories = Object.keys(data);

      let axis = [];

      if (Object.entries(data).length > 0 && Object.entries(data)[0][1]) {
        axis = Object.keys(Object.entries(data)[0][1]);
      }

      const getColorForName = (name) => {
        // Generate a hash from the name
        let hash = 0;
        for (let i = 0; i < name.length; i += 1) {
          hash = name.charCodeAt(i) + hash * 31;
          hash %= 0xffffffff; // Keep the hash within 32-bit range
        }

        // Convert the hash to a hexadecimal color code
        let color = '#';
        for (let i = 0; i < 3; i += 1) {
          const value = Math.floor(Math.abs(hash) / (256 ** i)) % 256;
          color += value.toString(16).padStart(2, '0');
        }

        return color;
      };

      const series = axis.map((el) => ({
        name: el,
        data: Object.values(data).map((option) => {
          const response = [];
          Object.entries(option).forEach(([key, val]) => {
            if (key === el) {
              response.push(val);
            }
          });
          return response;
        }),
        color: getColorForName(el),
      }));

      const openDrilldown = (opportunityowner) => {
        this.$emit('open-drilldown', {
          name: 'opportunities',
          filters: {
            owners: `${opportunityowner}`,
            openStage: true,
          },
        });
      };

      return {
        chart: {
          type: 'bar',
          style: {
            fontFamily: 'Open Sans',
          },
        },

        credits: {
          enabled: false,
        },

        title: {
          text: null,
        },

        xAxis: {
          categories,
        },

        yAxis: {
          allowDecimals: false,
        },

        legend: {
          reversed: true,
        },

        tooltip: {
          pointFormat: '{series.name}: <b>$ {point.y:,.2f}</b> <br>',
          shared: true,
        },

        plotOptions: {
          series: {
            stacking: 'normal',

            allowPointSelect: true,

            point: {
              events: {
                select(event) {
                  openDrilldown(event.target.category);
                },
              },
            },
          },
        },

        series,

        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                'printChart',
                'separator',
                'downloadPNG',
                'downloadJPEG',
                'downloadPDF',
                'downloadSVG',
              ],
            },
          },
        },
      };
    },
  },

  watch: {
    selected: {
      handler(value) {
        if (value === 'all') {
          this.$store.dispatch(
            'Graphs/fetchOpenOpportunitiesBySalesperson',
            { teamid: '', userid: '' },
          );
        } else if (value === 'self') {
          this.$store.dispatch(
            'Graphs/fetchOpenOpportunitiesBySalesperson',
            { teamid: '', userid: this.self },
          );
        } else if (value.toString().startsWith('team')) {
          this.$store.dispatch(
            'Graphs/fetchOpenOpportunitiesBySalesperson',
            { teamid: value.toString().substring(4), userid: '' },
          );
        } else {
          this.$store.dispatch(
            'Graphs/fetchOpenOpportunitiesBySalesperson',
            { teamid: '', userid: value },
          );
        }
      },

      deep: true,
    },
  },

  async created() {
    try {
      if (this.hasRole('ROLE_SALES_PERSON')) {
        await this.$store.dispatch(
          'Graphs/fetchOpenOpportunitiesBySalesperson',
          { teamid: '', userid: this.self },
        );
      } else {
        await this.$store.dispatch(
          'Graphs/fetchOpenOpportunitiesBySalesperson',
          { teamid: '', userid: '' },
        );
      }
      this.selected = this.hasRole('ROLE_SALES_PERSON') ? 'self' : 'all';
    } catch (error) {
      console.error(error);
    }
  },

};
</script>
